module.exports = __webpack_public_path__ + "static/img/login-logo.2de0b1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login-logo.png
// module id = DU3f
// module chunks = 8